"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkActionButton = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const Layers_1 = __importDefault(require("@material-ui/icons/Layers"));
const table_toolbar_button_1 = require("../table-toolbar-button");
const bulk_action_hook_1 = require("./bulk-action-hook");
const bulk_action_item_1 = require("./bulk-action-item");
function BulkActionButton({ disabled, actions }) {
    const anchorRef = (0, react_1.useRef)(null);
    const { openMenu, closeMenu, opened } = (0, bulk_action_hook_1.useBulkActionMenu)();
    const intl = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(table_toolbar_button_1.TableToolbarButton, { ref: anchorRef, disabled: disabled, label: react_1.default.createElement(Layers_1.default, null), onClick: openMenu, tooltip: intl.formatMessage({
                id: 'EAS_TABLE_BULK_ACTION_MENU_BTN',
                defaultMessage: 'Hromadné akce',
            }) }),
        react_1.default.createElement(Menu_1.default, { anchorEl: anchorRef.current, keepMounted: true, MenuListProps: {
                disablePadding: true,
            }, open: opened, onClose: closeMenu }, actions.map((action, i) => (react_1.default.createElement(bulk_action_item_1.BulkActionItem, { key: i, action: action, closeMenu: closeMenu }))))));
}
exports.BulkActionButton = BulkActionButton;
//# sourceMappingURL=bulk-action-button.js.map